var bordercolor = getComputedStyle(document.body).getPropertyValue('--bordercolor');
var bodycolor = getComputedStyle(document.body).getPropertyValue('--bodycolor');
var primarycolor = getComputedStyle(document.body).getPropertyValue('--vs-primary');
export default [
    {
       
        headerchart:
        {
            options:
            {
                chart: {
                    width: '100px',
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                grid: {
                    show: false,
                    padding: {
                        left: -20,
                        bottom: -15
                    }
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    lines: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false
                    },
                    lines: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
                fill: {
                    opacity: 1
                },
                bar: {
                    columnWidth: 4
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#1e3d73", '#17a2b8'],
            },
            series: [{
                name: 'PRODUCT A',
                data: [13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27,13, 23, 20]
            }, {
                name: 'PRODUCT B',
                data: [44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43,44, 55, 41]
            }],
        },
        mainbarchart:
        {
            data: {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                    label: 'Coronavirus Cases',
                    borderColor: primarycolor,
                    backgroundColor: 'rgba(30, 61, 115, 0.2)',
                    data: [10, 20, 39, 20, 54, 46, 79],
                    borderWidth: 1
                }, {
                    label: 'Recovered',
                    borderColor: '#17a2b8',
                    backgroundColor: 'rgba(23, 162, 184, 0.2)',
                    data: [27, 69, 22, 55, 31, 50, 30],
                    borderWidth: 1
                }]
            },
            options: {responsive: true,
                tooltips: {
                    mode: 'index',
                },
                hover: {
                    mode: 'index'
                },
                legend: {
                    position: 'top',
                    display: false,
                    labels: {
                        fontColor: bodycolor
                    }
                },
                scales: {
                    xAxes: [{
                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
                            },
                        }],
                    yAxes: [{

                            gridLines: {
                                display: true,
                                color: bordercolor,
                                zeroLineColor: bordercolor
                            },
                            ticks: {
                                fontColor: bodycolor,
                            }
                        }]
                }

            }
        }
    }
]
